var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gat-flex',{attrs:{"size":_vm.size}},[_c('v-card',{staticClass:"mr-0 mb-1 mt-3 subGrpCard elevation-0",attrs:{"text":""}},[(_vm.title)?_c('v-card-title',{staticClass:"mb-1 pa-0 cardTitle",class:_vm.margins},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('v-layout',{attrs:{"wrap":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }